import { render, staticRenderFns } from "./aup.vue?vue&type=template&id=0abfc94a&scoped=true&"
import script from "./aup.vue?vue&type=script&lang=ts&"
export * from "./aup.vue?vue&type=script&lang=ts&"
import style0 from "./aup.vue?vue&type=style&index=0&id=0abfc94a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abfc94a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AupHero: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/aup/AupHero.vue').default})
